import { ActionPlanRiskConsequence, ActionPlanRiskLikelihood, ActionPlanTopicTypeData, ActionPlanType, ActionPlanTypeData, CommandResult } from '../amorg-common';
import { ActionPlanView } from '../amorg-common';
import { PublicActionPlanLink, ActionPlanLinkConfiguration } from '../amorg-common';
import { SurveyTopic } from '../amorg-common';
import { ActionPlanListView, ArticleActionPlanListView } from '../amorg-common/DTOs/ActionPlanListView';
import { activitiesPath } from "./activityClientApi";
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

export const getActionPlanViewById = async (actionPlanId: string): Promise<ActionPlanView | null> =>
{
    const data:ActionPlanView | null = await queryAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/view`);
    return refineActionPlanView(data);
};

export const getArticleActionPlans = async (articleId: string): Promise<ArticleActionPlanListView[]> =>
{
    const data = await queryAuthWrapper(`${apiPath}/actionplans/article/${articleId}`) as ArticleActionPlanListView[];
    return data.map(item => {
        return {
            ...item,
            start: new Date(item.start),
            end: new Date(item.end),
        } as ArticleActionPlanListView;
    });
}

export const createActivityAndActionPlan = async (actionPlanId:string, activityId:string, typeData:ActionPlanTypeData, title:string, start:Date, end:Date) =>
    commandAuthWrapper(`${apiPath}/actionplans`, 'POST',
        { actionPlanId, activityId, typeData, title, start, end });

export const createActionPlan = async (actionPlanId: string, activityId: string, type: ActionPlanType) =>
    commandAuthWrapper(`${activitiesPath}/${activityId}/actionplans`, 'POST',
        { id: actionPlanId, type });

export const getActionPlansByActivityId = async (activityId: string): Promise<ActionPlanListView[]> =>
    queryAuthWrapper(`${activitiesPath}/${activityId}/actionplans`);

export const getActionPlanSurveyTopics = async (actionPlanId: string): Promise<SurveyTopic[]> =>
    queryAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/surveytopics`);

export const assignActionPlanOwner = async (actionPlanId: string, userId: string) =>
    commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/owner`, 'PUT', { userId });

export const updateActionPlan = async (actionPlanId: string, title: string, description: string) =>
    commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}`, 'PUT',
        { title, description });

export const updateActionPlanData = async (actionPlanId: string, typeData: ActionPlanTypeData) =>
    commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/typeData`, 'PUT',
        { typeData });

export const shareActionPlanLink = async (linkId: string, recipients:string[], message:string) =>
    commandAuthWrapper(`${apiPath}/actionplans/links/${linkId}/share`, 'POST',
        { recipients, message }
    );

export const deleteActionPlan = async (actionPlanId: string) =>
    commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}`, 'DELETE');







export async function getActionPlanFromLinkId (siteId: string, linkId: string): Promise<ActionPlanView | null>
{
    const data: ActionPlanView | null = await queryAuthWrapper(`${apiPath}/actionplans/links/${siteId}.${linkId}`);
    return refineActionPlanView(data);
}


export const getActionPlanList = async (): Promise<ActionPlanListView[]> =>
{
    const data:ActionPlanListView[] = await queryAuthWrapper(`${apiPath}/actionplans`);
    return data.map(item =>
    ({
        ...item,
        start: new Date(item.start),
        end: new Date(item.end),
    }));
};

export const getActionPlansForActiveUser = async (): Promise<ActionPlanListView[]> =>
{
    const data:ActionPlanListView[] = await queryAuthWrapper(`${apiPath}/actionplans/activeUser`);
    return data.map(item =>
    ({
        ...item,
        start: new Date(item.start),
        end: new Date(item.end),
    }));
};

export const createActionPlanTopic = async (actionPlanTopicId: string, actionPlanId: string) =>
    commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/topics`, 'POST',
        { actionPlanTopicId });

export const updateActionPlanTopicRisk = async (actionPlanTopicId: string, consequence:ActionPlanRiskConsequence, likelihood: ActionPlanRiskLikelihood) =>
{
    return commandAuthWrapper(`${apiPath}/actionplantopics/${actionPlanTopicId}/risk`, 'PUT',
        { risk:{consequence, likelihood } });
};

export const updateActionPlanTopicData = async (actionPlanTopicId: string, typeData: ActionPlanTopicTypeData) =>
{
    return commandAuthWrapper(`${apiPath}/actionplantopics/${actionPlanTopicId}/typeData`, 'PUT',
        { typeData });
};

export const updateActionPlanTopic = async (actionPlanTopicId: string, description: string) =>
    commandAuthWrapper(`${apiPath}/actionplantopics/${actionPlanTopicId}`, 'PUT',
        { description });

export const deleteActionPlanTopic = async (actionPlanTopicId: string) =>
    commandAuthWrapper(`${apiPath}/actionplantopics/${actionPlanTopicId}`, 'DELETE');

export async function createActionPlanLink (actionPlanId: string, linkId: string, configuration:ActionPlanLinkConfiguration): Promise<CommandResult>
{
    return await commandAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/links`, 'POST',
        { linkId, configuration });
}

export async function deleteActionPlanLink (linkId: string): Promise<CommandResult>
{
    return await commandAuthWrapper(`${apiPath}/actionplans/links/${linkId}`, 'DELETE');
}

export async function getActionPlanLinks(actionPlanId: string): Promise<PublicActionPlanLink[]>
{
    return await queryAuthWrapper(`${apiPath}/actionplans/${actionPlanId}/links`);
}


function refineActionPlanView(data: ActionPlanView): ActionPlanView
{
    if(data)
    {
        data.start = new Date(data.start);
        data.end = new Date(data.end);
        for(const t of data.topics)
        {
            for(const a of t.actionPoints)
            {
                a.deadline = a.deadline ? new Date(a.deadline) : null;
            }
        }

        if(data.type === 'Article')
        {
            data.articleData.date = data.articleData.date ? new Date(data.articleData.date) : null;
        }

        return data;
    }

    return null;
}